













import { IconSize, ParagraphSize } from '@getaccept/lib-ui';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: null,
    },
    isBold: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
    },
  },
  setup() {
    return {
      ParagraphSize,
      IconSize,
    };
  },
});
